import { render } from "./UnreadNotificationRow.vue?vue&type=template&id=784b7fc1&scoped=true"
import script from "./UnreadNotificationRow.vue?vue&type=script&lang=js"
export * from "./UnreadNotificationRow.vue?vue&type=script&lang=js"

import "./UnreadNotificationRow.vue?vue&type=style&index=0&id=784b7fc1&scoped=true&lang=css"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784b7fc1"]])

export default __exports__